import { createApp } from 'vue';
import BasketButton from './BasketButton.vue';
import { configureBasket, fetchBasket } from '@/shared/basketStore.js';
import { attachVueErrorHandler } from '@/shared/sentry.js';

const el = document.getElementById('basket-button');

if (el) {
    configureBasket({
        apiUrl: el.dataset.basketApiUrl,
        giftApiUrl: el.dataset.basketGiftApiUrl,
        monetaryVoucherApiUrl: el.dataset.basketMonetaryVoucherApiUrl,
        voucherApiUrl: el.dataset.basketVoucherApiUrl,
        checkoutUrl: el.dataset.basketCheckoutUrl,
    });

    fetchBasket();

    const app = createApp(BasketButton);
    attachVueErrorHandler(app);
    app.mount(el);
}
